import { buildFormTranslations } from "./buildFormTranslations";
import { FORM_CONFIG } from "routes.js";

function FormService(
	api,
	campaignService
) {
	const service = this;

	service.buildFormTranslations = buildFormTranslations;

	service.getFormById = async(formId) => {
		const formResponsePromise = api.get(FORM_CONFIG(formId));
		
		const campaignPromise = campaignService.loadCurrentCampaigns(formId);
		const [formResponse] = await Promise.all([formResponsePromise, campaignPromise]);

		return formResponse;
	};

	return service;
}

export default angular
	.module("vesl.services.form-service", [])
	.service("formService", FormService).name;